<template>
  <div id="lead-water-leak">
    <div class="ld-white-title">
      Location: <b>{{ alert.location }}</b>
    </div>
    <div class="location-image">
      <img
        v-if="alert.location === 'Water Heater'"
        src="@shared/assets/img/lead-detail/water-heater.png"
        alt="Water Heater"
        class="li-image"
      >
      <img
        v-else-if="alert.location === 'Toilet'"
        src="@shared/assets/img/lead-detail/toilet.png"
        alt="Toilet"
        class="li-image"
      >
      <img
        v-else-if="alert.location === 'Washing Machine'"
        src="@shared/assets/img/lead-detail/washing-machine.png"
        alt="Washing Machine"
        class="li-image"
      >
      <img
        v-else-if="alert.location === 'Sink'"
        src="@shared/assets/img/lead-detail/bathroom-sink.png"
        alt="Sink"
        class="li-image"
      >
      <img
        v-else-if="(alert.location === 'Attic'
          || alert.location === 'Closet'
          || alert.location === 'Basement')"
        src="@shared/assets/img/lead-detail/air-handler.png"
        alt="AC Drain Pan"
        class="li-image"
      >
      <img
        v-else
        src="@shared/assets/img/leads/water-drop-icon.png"
        alt="Water Leak Sensor"
        class="li-image"
      >
    </div>
    <div class="ld-timeline">
      <div class="ld-flex-left">
        <div class="ld-leak-title">
          Started
        </div>
        <div class="ld-leak-text">
          {{ formattedDate(alert.startTime) }}
        </div>
      </div>
      <div class="ld-flex-right">
        <div class="ld-leak-title">
          Last Occurred
        </div>
        <div class="ld-leak-text">
          {{ formattedDate(alert.lastOccurred) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import leadDetailMixin from '@shared/mixins/leadDetailMixin';

export default {
  name: 'WaterLeakLocation',
  mixins: [leadDetailMixin],
  methods: {
    formattedDate(time) {
      return moment(time).format('MMM Do YYYY');
    },
  },
};
</script>

<style lang="scss">

#lead-water-leak {
  background-color: $N110;
  padding: 3rem;
  justify-items: center;
  display: grid;

  .ld-white-title {
    color: $WHITE;
    font-size: 12pt;
    line-height: 15px;
  }

  .ld-timeline {
    display: grid;
    grid-auto-flow: column;
    justify-content: space-between;
    width: 100%;

    .ld-flex-left {
      align-items: flex-start;
    }

    .ld-flex-right {
      text-align: right;
    }

    .ld-leak-title {
      color: $WHITE;
      font-size: 10pt;
      font-weight: 600;
    }

    .ld-leak-text {
      color: $WHITE;
      font-size: 12pt;
    }
  }

  .location-image {
    display: grid;
    justify-self: center;
    padding: 2rem;

    .li-image {
      height: 130pt;
      width: 130pt;
      object-fit: contain;
    }
  }
}
</style>
